import { supabase } from "../lib/api";

export enum LinkStatus {
  PRIVATE = "private",
  QUEUE = "queue",
  PUBLISHED = "published",
}

type addLinkProps = {
  url: string;
  title: string;
  description: string;
  tagId: number;
  userId: string;
  authorUsername: string;
};

export const addLink = async (newLink: addLinkProps) => {
  const { url, title, description, tagId, userId, authorUsername } = newLink;

  // ok = 201, 200
  if (url.length > 3) {
    return await supabase
      .from("links")
      .insert([
        {
          url: url,
          title: title,
          description: description,
          tag_id: tagId,
          status: LinkStatus.PRIVATE,
          user_id: userId,
          author_username: authorUsername,
        },
      ])
      .select();
  }
};
